"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchByFilter = void 0;
const AbstractSearchCommand_1 = require("./AbstractSearchCommand");
class SearchByFilter extends AbstractSearchCommand_1.AbstractSearchCommand {
    constructor(filter) {
        super();
        this.execute = async (api, page, pageSize) => {
            const appList = this.applyPushApplicationFilter(await this.getAllApplications(api), this.filter);
            return {
                total: appList.length,
                list: this.getPage(appList, page, pageSize),
            };
        };
        this.filter = filter;
    }
}
exports.SearchByFilter = SearchByFilter;
//# sourceMappingURL=SearchByFilter.js.map